import SafeHtml from '../../SafeHtml.jsx';

// This list is for display only. Adding a new platform here does not allow
// it to render - its domain must also be added to allowedIframeDomains in
// SafeHtml.jsx, otherwise the embed's iframe src will be stripped out.
const SUPPORTED_PLATFORMS = ['YouTube', 'Vimeo', 'Loom', 'Wistia', 'Tella', 'Livid'];

const EditVideoEmbedForm = ({ settings, setSettings }) => {
    return (
        <div>
            <label htmlFor="video-embed-code" className="input-label mt-4">
                Embed Code
            </label>
            <textarea
                id="video-embed-code"
                value={settings?.embed || ''}
                onChange={e =>
                    setSettings({ ...settings, embed: e.target.value })
                }
                placeholder='<iframe src="https://www.youtube.com/embed/..." ...></iframe>'
                className="w-full min-h-32 font-mono text-sm"
            />
            <div className="text-gray-500 text-sm mt-1 ml-4">
                Paste the embed code from {SUPPORTED_PLATFORMS.join(', ')}{' '}
                (usually found under a "Share" or "Embed" option). Other video
                providers are not currently supported.
            </div>

            {!!settings?.embed && (
                <div className="mt-4">
                    <div className="input-label">Preview</div>
                    <SafeHtml html={settings.embed} />
                </div>
            )}
        </div>
    );
};

export default EditVideoEmbedForm;
